import TopMenu from "../TopMenu/TopMenu";

type HeaderProps = {};

const Header = (props: HeaderProps) => {
  return (
    <>
      <TopMenu />
    </>
  );
};

export default Header;
